import script from "./CoeCategoryListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CoeCategoryListComponent.vue?vue&type=script&setup=true&lang=js"

import "./CoeCategoryListComponent.vue?vue&type=style&index=0&id=6ae878c1&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae878c1"]])

export default __exports__